export class FakeApp {
  providers: { key: string; value: any }[] = [];

  component(): void {
    // pass
  }

  config = {
    globalProperties: {},
  };

  provide(key: string, value: any) {
    this.providers.push({ key, value });
  }

  unmount() {
    // pass
  }

  use(plugin: any) {
    plugin.install(this);
  }
}
